<!-- Basic Badges Starts -->
<div class="row">
  <div class="col-12">
    <div class="content-header">Badges</div>
  </div>
</div>
<section id="basic-badges">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Basic Badges</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Use <code>.badge.badge-&#123;color&#125;</code> within element to create badge with different color options.</p>
            <span class="badge badge-primary mb-1 mr-2">Primary</span>
            <span class="badge badge-secondary mb-1 mr-2">Secondary</span>
            <span class="badge badge-success mb-1 mr-2">Success</span>
            <span class="badge badge-danger mb-1 mr-2">Danger</span>
            <span class="badge badge-info mb-1 mr-2">Info</span>
            <span class="badge badge-warning mb-1 mr-2">Warning</span>
            <span class="badge badge-light mb-1 mr-2">Light</span>
            <span class="badge badge-dark mb-1">Dark</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Basic Badges ends-->

<!-- Light Badges Starts -->
<section id="light-badges">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Light Badges</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Use <code>.badge.bg-light-&#123;color&#125;</code> to create light badge with different color options.</p>
            <span class="badge bg-light-primary mb-1 mr-2">Primary</span>
            <span class="badge bg-light-secondary mb-1 mr-2">Secondary</span>
            <span class="badge bg-light-success mb-1 mr-2">Success</span>
            <span class="badge bg-light-danger mb-1 mr-2">Danger</span>
            <span class="badge bg-light-info mb-1 mr-2">Info</span>
            <span class="badge bg-light-warning mb-1">Warning</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Light Badges ends-->

<!-- Badges with icon Starts -->
<section id="icon-badges">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Badges with Icons</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Use <code>.badge.badge-&#123;color&#125;</code> for badge colors and use <code>i</code> for icons.</p>
            <span class="badge badge-primary mb-1 mr-2"><i class="ft-camera"></i></span>
            <span class="badge badge-secondary mb-1 mr-2"><i class="ft-bell"></i></span>
            <span class="badge badge-success mb-1 mr-2"><i class="ft-check-circle"></i></span>
            <span class="badge badge-danger mb-1 mr-2"><i class="ft-trash"></i></span>
            <span class="badge badge-info mb-1 mr-2"><i class="ft-info"></i></span>
            <span class="badge badge-warning mb-1 mr-2"><i class="ft-alert-triangle"></i></span>
            <span class="badge badge-light mb-1 mr-2"><i class="ft-tag"></i></span>
            <span class="badge badge-dark mb-1"><i class="ft-user"></i></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Badges with icon ends -->


<!-- Badge With Components Starts -->
<section id="component-badges">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Badge With Components</div>
      <p class="content-sub-header mb-1">Easily highlight new or unread items by adding a <code>&lt;span class="badge"&gt;</code> to links, Bootstrap navs, and more.</p>
    </div>
  </div>
  <div class="row match-height">
    <div class="col-12 col-md-6 col-lg-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Badge with Link</h4>
          <p>Use badge class in anchor tag for badge with link.</p>
        </div>
        <div class="card-content">
          <div class="card-body text-center">
            <a href="javascript:;">Inbox <span class="badge badge-secondary">42</span></a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Badge with button</h4>
          <p>Use badge class in button tag for badge with button.</p>
        </div>
        <div class="card-content">
          <div class="card-body text-center">
            <button class="btn btn-danger" type="button">
              Messages <span class="badge badge-light">4</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Adapts to active nav states</h4>
          <p>Built-in styles are included for placing badges in active states in pill navigations.</p>
        </div>
        <div class="card-content">
          <div class="card-body text-center">
            <ul class="nav nav-pills" role="tablist">
              <li role="presentation" class="nav-item"><a href="javascript:;" class="nav-link active">Home <span class="badge badge-success">42</span></a></li>
              <li role="presentation" class="nav-item"><a class="nav-link">Profile</a></li>
              <li role="presentation" class="nav-item"><a class="nav-link">Messages <span class="badge badge-warning">3</span></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Badge With Components ends -->

<!-- Bacis Pill Badges Starts -->
<section id="pill-badges">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Pill Badges</div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Basic Pill Badges</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Use the <code>.badge-pill</code> modifier to make badges more rounded (with a larger border-radius).</p>
            <span class="badge badge-pill badge-primary mb-1 mr-2">Primary</span>
            <span class="badge badge-pill badge-secondary mb-1 mr-2">Secondary</span>
            <span class="badge badge-pill badge-success mb-1 mr-2">Success</span>
            <span class="badge badge-pill badge-danger mb-1 mr-2">Danger</span>
            <span class="badge badge-pill badge-info mb-1 mr-2">Info</span>
            <span class="badge badge-pill badge-warning mb-1 mr-2">Warning</span>
            <span class="badge badge-pill badge-light mb-1 mr-2">Light</span>
            <span class="badge badge-pill badge-dark mb-1">Dark</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Bacis Pill Badges ends -->

<!-- Light Pill Badges Starts -->
<section id="light-pill-badges">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Light Pill Badges</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Use the <code>.badge-pill.bg-light-&#123;color&#125;</code> to make light badges more rounded.</p>
            <span class="badge badge-pill bg-light-primary mb-1 mr-2">Primary</span>
            <span class="badge badge-pill bg-light-secondary mb-1 mr-2">Secondary</span>
            <span class="badge badge-pill bg-light-success mb-1 mr-2">Success</span>
            <span class="badge badge-pill bg-light-danger mb-1 mr-2">Danger</span>
            <span class="badge badge-pill bg-light-info mb-1 mr-2">Info</span>
            <span class="badge badge-pill bg-light-warning mb-1">Warning</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Light Pill Badges ends -->

<!-- Pill Badges with icon Starts -->
<section id="icon-pill-badges">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Pill Badges with Icons</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Use <code>.badge.badge-pill.badge-&#123;color&#125;</code> for colored pill badges and use <code>i</code> for icons.</p>
            <span class="badge badge-pill badge-primary mb-1 mr-2"><i class="ft-camera"></i></span>
            <span class="badge badge-pill badge-secondary mb-1 mr-2"><i class="ft-bell"></i></span>
            <span class="badge badge-pill badge-success mb-1 mr-2"><i class="ft-check-circle"></i></span>
            <span class="badge badge-pill badge-danger mb-1 mr-2"><i class="ft-trash"></i></span>
            <span class="badge badge-pill badge-info mb-1 mr-2"><i class="ft-info"></i></span>
            <span class="badge badge-pill badge-warning mb-1 mr-2"><i class="ft-alert-triangle"></i></span>
            <span class="badge badge-pill badge-light mb-1 mr-2"><i class="ft-tag"></i></span>
            <span class="badge badge-pill badge-dark mb-1"><i class="ft-user"></i></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Pill Badges with icon ends -->
